import React, { useState, useEffect } from 'react';
import { getAccess } from '@/lib/api';
import { Key, Loader2, Shield, Wifi } from 'lucide-react';

export default function MyAccess() {
  const [accessKeys, setAccessKeys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAccess().then(setAccessKeys).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center py-20"><Loader2 className="w-6 h-6 text-[#3A4035] animate-spin" /></div>;

  const access = accessKeys[0];

  return (
    <div className="animate-fade-in" data-testid="my-access-page">
      <div className="mb-8">
        <h1 className="font-heading text-2xl sm:text-3xl font-medium text-[#1A1A1A] tracking-tight">Access</h1>
        <p className="text-sm text-[#5C5C55] mt-1">Your digital key and access information</p>
      </div>

      {access ? (
        <div className="space-y-4">
          <div className="bg-white rounded-2xl border border-[#E5E2DC] shadow-[0_2px_10px_rgba(0,0,0,0.02)] p-6 sm:p-8" data-testid="access-card">
            <div className="flex items-center gap-3 mb-6">
              <div className={`w-12 h-12 rounded-2xl flex items-center justify-center ${access.status === 'active' ? 'bg-[#E8EDE5]' : 'bg-[#F4EFE6]'}`}>
                <Key className={`w-6 h-6 ${access.status === 'active' ? 'text-[#3A4035]' : 'text-[#7A6849]'}`} strokeWidth={1.5} />
              </div>
              <div>
                <h2 className="font-heading text-lg font-medium text-[#1A1A1A]">Digital Key</h2>
                <span className={`text-xs px-3 py-1 rounded-full font-semibold capitalize ${access.status === 'active' ? 'bg-[#E8EDE5] text-[#3A4035]' : 'bg-[#F4EFE6] text-[#7A6849]'}`}>
                  {access.status}
                </span>
              </div>
            </div>

            <div className="space-y-4">
              {access.code && (
                <div className="bg-[#F2F0EB] rounded-xl p-4 text-center">
                  <p className="text-xs text-[#8A8B85] mb-1">Access Code</p>
                  <p className="text-2xl font-heading font-medium text-[#1A1A1A] tracking-wider">{access.code}</p>
                </div>
              )}
              <div className="flex items-center justify-between py-3 border-b border-[#F2F0EB]">
                <span className="text-sm text-[#5C5C55]">Type</span>
                <span className="text-sm font-medium text-[#1A1A1A] capitalize">{access.key_type}</span>
              </div>
              {access.issued_date && (
                <div className="flex items-center justify-between py-3">
                  <span className="text-sm text-[#5C5C55]">Issued</span>
                  <span className="text-sm font-medium text-[#1A1A1A]">{access.issued_date}</span>
                </div>
              )}
            </div>
          </div>

          <div className="bg-[#F2F0EB] rounded-2xl p-5">
            <div className="flex items-center gap-2 mb-2">
              <Shield className="w-4 h-4 text-[#5C5C55]" strokeWidth={1.5} />
              <span className="text-xs font-semibold text-[#5C5C55] uppercase tracking-wider">Security Notice</span>
            </div>
            <p className="text-sm text-[#5C5C55]">Do not share your access code with anyone. Report lost or compromised keys immediately via a support ticket.</p>
          </div>
        </div>
      ) : (
        <div className="text-center py-16">
          <Key className="w-10 h-10 text-[#D8DBD3] mx-auto mb-3" strokeWidth={1.5} />
          <p className="text-sm text-[#8A8B85]">No access key assigned yet</p>
        </div>
      )}
    </div>
  );
}
